var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"mode":"out-in","name":"fade"}},_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:index,staticClass:"alert",class:{
      'alert-success': alert.status === 'success',
      'alert-danger': alert.status === 'error',
    },attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.I18n.t(("employees.auctions_catalogs.internet_orders." + (alert.message)), { count: _vm.formatPrice(alert.value) }))+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18a50806","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/employees_orders_panel/components/orders/alerts.vue
// module id = 662
// module chunks = 0 1 2 3 4 5 6 7 8 10 20 22 25 299